/*
 * ta-reveal — scroll-reveal controller
 *
 * Adds `.is-in` to any [data-reveal] element when it scrolls into view and
 * removes it when it scrolls back out (so animations replay on scroll up/down,
 * matching AOS's reset behaviour). Use data-reveal-once="true" to opt out of the
 * reset and animate a single time.
 *
 * Re-initialises sections reloaded by the Shopify theme editor.
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var root = document.documentElement;
  root.classList.add('ta-reveal-ready');

  // Reveal a touch before the element is fully in view; reset once it leaves.
  var observer = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        var el = entry.target;
        var once = el.getAttribute('data-reveal-once') === 'true';

        if (entry.isIntersecting) {
          el.classList.add('is-in');
          if (once) observer.unobserve(el);
        } else if (!once) {
          el.classList.remove('is-in');
        }
      }
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.01 }
  );

  function px(value, suffix) {
    var n = parseInt(value, 10);
    return isNaN(n) ? null : n + suffix;
  }

  function applyInlineVars(el) {
    var delay = px(el.getAttribute('data-reveal-delay'), 'ms');
    if (delay !== null) el.style.setProperty('--ta-reveal-delay', delay);

    var duration = px(el.getAttribute('data-reveal-duration'), 'ms');
    if (duration !== null) el.style.setProperty('--ta-reveal-duration', duration);

    var distance = px(el.getAttribute('data-reveal-distance'), 'px');
    if (distance !== null) el.style.setProperty('--ta-reveal-distance', distance);
  }

  // Auto-stagger: give each reveal inside a [data-reveal-group] an incremental
  // delay so children cascade in. An explicit data-reveal-delay always wins.
  function applyGroupStagger(scope) {
    var groups = scope.querySelectorAll('[data-reveal-group]');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var step = parseInt(group.getAttribute('data-reveal-stagger'), 10);
      if (isNaN(step)) step = 100;
      var base = parseInt(group.getAttribute('data-reveal-delay'), 10) || 0;

      var items = group.querySelectorAll('[data-reveal]');
      var index = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].hasAttribute('data-reveal-delay')) continue;
        items[i].style.setProperty('--ta-reveal-delay', base + index * step + 'ms');
        index++;
      }
    }
  }

  function init(scope) {
    if (!scope) scope = document;
    if (scope.hasAttribute && scope.hasAttribute('data-reveal-group')) {
      applyGroupStagger(scope.parentNode || document);
    } else {
      applyGroupStagger(scope);
    }

    var nodes = scope.querySelectorAll('[data-reveal]');
    for (var i = 0; i < nodes.length; i++) {
      applyInlineVars(nodes[i]);
      observer.observe(nodes[i]);
    }
  }

  function start() {
    init(document);
    window.__taRevealInit = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Shopify theme editor: animate sections as they are re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
